// extracted by mini-css-extract-plugin
export default {"base":"WSContainer-module_base-ueyZl","verticalPadding":"WSContainer-module_verticalPadding-badHU"};